import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import JalaliDatePicker from "../../../components/shared/jalali-datepicker";
import { formatApiDate } from "../../SLN/market-growth/utils/commissionValidation";

const UpdateTeamShareDialog = ({ open, onClose, member, onSubmit, saving }) => {
  const [form, setForm] = useState({
    sharePercentOfParentCommission: "",
    effectiveFrom: new Date(),
  });
  const [errors, setErrors] = useState({});
  const [submitError, setSubmitError] = useState(null);

  useEffect(() => {
    if (!open || !member) return;
    setForm({
      sharePercentOfParentCommission: member.currentSharePercent ?? "",
      effectiveFrom: new Date(),
    });
    setErrors({});
    setSubmitError(null);
  }, [open, member]);

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) setErrors((prev) => ({ ...prev, [field]: null }));
    if (submitError) setSubmitError(null);
  };

  const handleSubmit = async () => {
    const share = Number(form.sharePercentOfParentCommission);
    const nextErrors = {};
    if (!share || share <= 0 || share > 100) {
      nextErrors.sharePercentOfParentCommission = "سهم باید بین ۱ تا ۱۰۰ باشد.";
    }
    if (!form.effectiveFrom) nextErrors.effectiveFrom = "تاریخ شروع الزامی است.";
    if (Object.keys(nextErrors).length) {
      setErrors(nextErrors);
      return;
    }
    const result = await onSubmit({
      sharePercentOfParentCommission: share,
      effectiveFrom: formatApiDate(form.effectiveFrom),
    });
    if (result?.error) setSubmitError(result.error);
  };

  if (!member) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>تنظیم سهم — {member.displayName || member.userId}</DialogTitle>
      <DialogContent dividers>
        {submitError ? (
          <Alert severity="error" sx={{ mb: 2 }}>
            {submitError}
          </Alert>
        ) : null}
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="سهم از پورسانت والد (%)"
              type="number"
              value={form.sharePercentOfParentCommission}
              onChange={(e) => handleChange("sharePercentOfParentCommission", e.target.value)}
              fullWidth
              required
              error={Boolean(errors.sharePercentOfParentCommission)}
              helperText={errors.sharePercentOfParentCommission}
            />
          </Grid>
          <Grid item xs={12}>
            <JalaliDatePicker
              label="تاریخ شروع اعتبار"
              value={form.effectiveFrom}
              onChange={(value) => handleChange("effectiveFrom", value ? new Date(value) : null)}
              fullWidth
              error={Boolean(errors.effectiveFrom)}
              helperText={errors.effectiveFrom}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          انصراف
        </Button>
        <Button variant="contained" onClick={handleSubmit} disabled={saving}>
          {saving ? "در حال ذخیره..." : "ذخیره"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateTeamShareDialog;
